// @flow
import React from 'react';
import { Box, Text } from 'Common/components';
import { BINGE_WATCHING_PERIOD } from 'Common/bingewatching/Utils';

type Props = {| seconds: number |};

class CountdownCircle extends React.Component<Props> {
  mapSecondsToDegrees = (secondsLeft: number) => (secondsLeft / BINGE_WATCHING_PERIOD) * 360;

  render() {
    const { seconds } = this.props;

    return (
      <Box>
        <SVGCircle radius={this.mapSecondsToDegrees(seconds)} />
        <Text
          style={() => ({
            color: 'white',
            fontSize: 25,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          })}
        >
          {seconds}
        </Text>
      </Box>
    );
  }
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

function describeArc(x, y, radius, startAngle, endAngle) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);

  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

  const d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(
    ' ',
  );

  return d;
}

const SVGCircle = ({ radius }) => (
  <svg style={{ height: 60, width: 60 }}>
    <path fill="none" stroke="#fff" strokeWidth="3" d={describeArc(30, 30, 28, 0, radius)} />
  </svg>
);

export default CountdownCircle;
